import vue from 'vue'
import { deleteMethods } from '@/components/tools/index.js'
import viewPage from '@/core/component/viewPage'
const that = vue.prototype
export default {
  className: 'secondaryClassification',
  defaultOrder: 'weight',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '分类名称不可为空'
      ]
    },
    {
      name: 'image',
      tooltip: '尺寸1 : 1，建议156px * 156px',
      validators: [
        (val) => val ? null : '图片不可为空'
      ]
    },
    {
      name: 'category',
      listWhere: (where) => {
        where.objectId = {
          $ne: 'tzC3HnKB50'
        }
      },
      validators: [
        (val) => val ? null : '所属分类不可为空'
      ]
    },
    {
      name: 'weight',
      validators: [
        (val) => val ? null : '排序不可为空'
      ]
    }
  ],
  search: [
    'name',
    'category'
  ],
  action: {
    view: {
      type: 'row',
      text: '查看',
      hidden ({ record, tags }) {
        if (record && (record.objectId !== '80dkpxb8rC')) return true
      },
      viewTitle: '查看二级分类',
      component: viewPage
    },
    edit: false,
    newEdit: {
      type: 'row',
      text: '编辑',
      hidden ({ record, tags }) {
        if (record && (record.objectId === '80dkpxb8rC')) return true
      },
      component: 'akModelEditor'
    },
    delete: {
      type: 'row',
      text: '删除',
      hidden ({ record, tags }) {
        if (record && (record.objectId === '80dkpxb8rC')) return true
      },
      callback: deleteMethods
    }
  },
  hooks: {
    /**
     * 去掉促销礼品查询
     * @date: 2020/3/9
     */
    beforeFetch ({ where }) {
      // where.objectId = {
      //   $ne: '80dkpxb8rC'
      // }
    },
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      if (!data.name) { data.name = '促销礼品' }
      let res = await that.$modelAjax.getList('secondaryClassification', {
        params: {
          where: {
            name: data.name
          }
        }
      })
      // 判断是否已有相同名字的分类
      if ((options.objectId && res.length && res[0].objectId !== options.objectId) || (!options.objectId && res.length)) {
        throw that.$notification['error']({
          message: '已有此名称分类',
          description: '请重新输入'
        })
      }
    }
  }
}
